import { DISTRIBUTION_DETAILS_ALLOCATED } from "../../constants/routes";
import { useSellarDistributionCollection } from "../../hooks/api/v2/sellarDistributionCollection/useSellarDistributionCollection";
import { useParamAsNumber } from "../../hooks/useParamAsNumber";
import { DistributionDetailsContent } from "./DistributionDetailsContent";

export const DistributionAllocatedDetails = () => {
  const taskId = useParamAsNumber(DISTRIBUTION_DETAILS_ALLOCATED, "taskId");

  const { data: collection, isLoading } =
    useSellarDistributionCollection(taskId);

  return (
    <DistributionDetailsContent
      collection={collection}
      isLoading={isLoading}
      pickingListReference={{ type: "allocated", id: taskId }}
    />
  );
};
